type UnityRuntime = { Quit: () => Promise<unknown> };
type UnityHost = {
  unityInstance?: unknown;
  wglw_leaveChannel?: () => Promise<unknown>;
};

const releases = new WeakMap<UnityRuntime, Promise<void>>();

/** Voice callbacks may continue while Quit runs, including from Unity's own Dispose. */
export function releaseUnity(instance: UnityRuntime, host: UnityHost): Promise<void> {
  const existing = releases.get(instance);
  if (existing) return existing;
  // Keep an inert callback target until the next runtime replaces it. An older
  // deployed Agora wrapper can deliver late callbacks even after channel.leave().
  // This object holds no reference to the Unity runtime or its WebAssembly heap.
  if (host.unityInstance === instance) host.unityInstance = { SendMessage: () => {} };
  const leaveVoice = host.wglw_leaveChannel;
  const operation = Promise.resolve().then(async () => {
    try {
      await instance.Quit();
    } finally {
      // Explicitly release the legacy SDK before Level 1 joins with the same UID.
      // Its waveform timer must also stop when Unity does not complete Dispose.
      if (leaveVoice) await leaveVoice();
    }
  });
  releases.set(instance, operation);
  return operation;
}
